import { getFullName } from '@/utils/name';
import { isDescLang } from '@/settings/i18n';

export type Contact = {
  id: number;
  organizationId: number;
  corporationName: string;
  departmentName: string;
  postalCode?: string;
  address?: string;
  firstName: string;
  lastName: string;
  kanaFirstName: string;
  kanaLastName: string;
  phoneNumber: string;
  email: string;
  ccEmail?: string;
  addressee?: string;
};

const defaultContact: Contact = {
  id: 0,
  organizationId: 0,
  corporationName: '',
  departmentName: '',
  postalCode: '',
  address: '',
  firstName: '',
  lastName: '',
  kanaFirstName: '',
  kanaLastName: '',
  phoneNumber: '',
  email: '',
  ccEmail: '',
  addressee: '',
};

export const contactFactory = (contactAttrs?: {
  [P in keyof Contact]?: Contact[P];
}): Contact => ({
  ...defaultContact,
  ...contactAttrs,
});

export const classifiedJoin = (elems: any[], separator = ' ') => {
  const newElems = isDescLang() ? [...elems] : elems.reverse();

  return newElems.join(separator).trim();
};

export const summarize = (contact: Contact, separator = ' ') => {
  if (isDescLang()) {
    return [
      contact.corporationName,
      contact.departmentName,
      getFullName(contact.firstName, contact.lastName, ''),
      contact.addressee,
    ]
      .join(separator)
      .trim();
  }

  return [
    getFullName(contact.firstName, contact.lastName, ''),
    contact.departmentName,
    contact.corporationName,
  ]
    .join(separator)
    .trim();
};
